import requestFunctions from "../../functions/requestFunctions";


export const state = {

  CONTACTS_CATEGORIES_ITEM: {},
  CONTACTS_CATEGORIES_LIST: [],
  
  CONTACTS_CATEGORIES_TABLE_DATA: [],
  CONTACTS_CATEGORIES_LIST_DATA: [],
  CONTACTS_CATEGORIES_TOTAL_ROWS: 0

}

export const getters = {
  GET_CONTACTS_CATEGORIES_ITEM: (state) => {
    return state.CONTACTS_CATEGORIES_ITEM;
  },
  GET_CONTACTS_CATEGORIES_LIST: (state) => {
    return state.CONTACTS_CATEGORIES_LIST;
  },
  GET_CONTACTS_CATEGORIES_TABLE_DATA: (state) => {
    return state.CONTACTS_CATEGORIES_TABLE_DATA;
  },
  GET_CONTACTS_CATEGORIES_LIST_DATA: (state) => {
    return state.CONTACTS_CATEGORIES_LIST_DATA;
  },
  GET_CONTACTS_CATEGORIES_TOTAL_ROWS: (state) => {
    return state.CONTACTS_CATEGORIES_TOTAL_ROWS;
  }
}

export const mutations = {
  UPDATE_CONTACTS_CATEGORIES_ITEM(state, item) {
    state.CONTACTS_CATEGORIES_ITEM = item;
  },
  UPDATE_CONTACTS_CATEGORIES_LIST(state, list) {

    state.CONTACTS_CATEGORIES_LIST = list.total;
    state.CONTACTS_CATEGORIES_TABLE_DATA = [];
    state.CONTACTS_CATEGORIES_LIST_DATA = [];

    state.CONTACTS_CATEGORIES_TOTAL_ROWS = list.total;
    list = list.data;

    list.forEach(el => {

      let status = '';

      if(el.status === 'active'){
        status = 'Активный'
      }
      if(el.status === 'wait'){
        status = 'Ожидает активации'
      }
      if(el.status === 'disabled'){
        status = 'Не активна'
      }

      let user_data = '';
    
      if(el.profile_fullname !== null){
        user_data = el.profile_fullname;
      }
      
      if(el.user_phone !== null ){
        if(user_data !== ''){
          user_data = user_data + ', ';
        }
        user_data = user_data + el.user_phone;
      }

      state.CONTACTS_CATEGORIES_TABLE_DATA.push({
        'created_at' : el.created_at,
        'id'   : el.id,
        'code' : el.code,
        'name' : el.name,
        'contacts_qnt' : el.contacts_qnt,
        'comments' : el.comments,
        'status' : status,
        'user_data' : user_data,
        'uuid' : el.uuid
      });

      state.CONTACTS_CATEGORIES_LIST_DATA.push({
        id   : el.id,
        name : el.name,
      });

    });
  },
}

export const actions = {

  async FETCH_CONTACTS_CATEGORIES_ITEM({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/contacts/categories/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_CONTACTS_CATEGORIES_ITEM', response.data);
      return response.data;
    }

  },

  async FETCH_CONTACTS_CATEGORIES_LIST({ commit }, payload = {}) {

    let query_url = 'https://api.client.za-bota.com/v1/contacts/categories';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_CONTACTS_CATEGORIES_LIST', response.data);
      return response.data;
    }

  },

  async FETCH_CONTACTS_CATEGORIES_CREATE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/contacts/categories';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'POST');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

  async FETCH_CONTACTS_CATEGORIES_UPDATE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/contacts/categories/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'PUT');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

  async FETCH_CONTACTS_CATEGORIES_DELETE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/contacts/categories/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'DELETE');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

}